import { createContext, useContext, useState, useCallback, useMemo } from "react";

export const translations = {
  es: {
    nav: {
      services: "Servicios",
      gallery: "Galería",
      booking: "Reservar",
      contact: "Contacto",
      callNow: "Llamar Ahora",
    },
    hero: {
      kicker: "Servicio Mecánico Móvil · Providence, RI",
      title1: "TU MECÁNICO",
      title2: "DE CONFIANZA",
      titleAccent: "SOBRE RUEDAS",
      subtitle:
        "Llevamos el taller hasta donde estés. Servicio rápido, honesto y profesional para tu vehículo en Providence y alrededores.",
      ctaPrimary: "Reservar Servicio",
      ctaSecondary: "WhatsApp",
      stats: [
        { k: "5★", v: "Atención Bilingüe" },
        { k: "24/7", v: "Asistencia en Carretera" },
        { k: "100%", v: "Trabajo Honesto" },
      ],
    },
    ticker: [
      "Diagnóstico Profesional",
      "Servicio a Domicilio",
      "Atención Bilingüe",
      "Trabajo Garantizado",
      "Precios Honestos",
      "Llegada Rápida",
    ],
    services: {
      kicker: "Lo que hacemos",
      title: "SERVICIOS",
      titleAccent: "MÓVILES",
      subtitle:
        "Reparaciones reales, hechas donde estés. Sin remolques, sin esperas largas.",
      items: [
        {
          name: "Cambio de Batería",
          desc: "Reemplazo rápido y prueba de carga del sistema eléctrico.",
        },
        {
          name: "Frenos",
          desc: "Pastillas, rotores y servicio completo del sistema de frenado.",
        },
        {
          name: "Afinaciones",
          desc: "Bujías, filtros y mantenimiento general para máximo rendimiento.",
        },
        {
          name: "Diagnóstico con Escáner",
          desc: "Lectura profesional de códigos OBD-II en tu domicilio.",
        },
        {
          name: "Cambio de Aceite",
          desc: "Aceite y filtro de calidad. Convencional, sintético o blend.",
        },
        {
          name: "Alternadores y Starters",
          desc: "Diagnóstico y reemplazo de alternadores, marchas y baterías.",
        },
        {
          name: "Inspección Pre-Compra",
          desc: "Revisión completa antes de comprar tu próximo auto usado.",
        },
        {
          name: "Asistencia en Carretera",
          desc: "Rescates, arranques y reparaciones de emergencia.",
        },
      ],
    },
    gallery: {
      kicker: "Trabajo en acción",
      title: "EN EL",
      titleAccent: "GARAJE",
      subtitle: "Resultados reales. Trabajo limpio y profesional.",
    },
    booking: {
      kicker: "Solicita tu cita",
      title: "RESERVA",
      titleAccent: "TU SERVICIO",
      subtitle:
        "Cuéntanos qué necesita tu carro y dónde estás. Te contactamos para confirmar.",
      trust: [
        { t: "Llegada Rápida", d: "Respuesta el mismo día en Providence y alrededores." },
        { t: "Diagnóstico Honesto", d: "Te explicamos el problema real antes de cobrar." },
        { t: "Atención Bilingüe", d: "Hablamos español e inglés. Sin malentendidos." },
        { t: "Garantía por Escrito", d: "Respaldamos cada trabajo realizado." },
      ],
      form: {
        name: "Nombre completo",
        phone: "Teléfono",
        location: "Ubicación / Dirección",
        vehicle: "Vehículo (Año / Marca / Modelo)",
        serviceType: "Tipo de servicio",
        description: "Describe el problema",
        submit: "Enviar Solicitud",
        sending: "Enviando...",
        success: "¡Solicitud enviada! Te contactaremos muy pronto.",
        error: "No pudimos enviar tu solicitud. Intenta de nuevo o llama al (417) 514-0081.",
        selectService: "Selecciona un servicio",
      },
    },
    contact: {
      kicker: "Estamos a una llamada",
      title: "LLÁMANOS",
      titleAccent: "AHORA",
      phone: "Teléfono",
      whatsapp: "WhatsApp",
      area: "Área de Servicio",
      areaValue: "Providence, RI y alrededores",
    },
    footer: {
      tagline: "Tu mecánico de confianza sobre ruedas.",
      rights: "Todos los derechos reservados.",
    },
  },
  en: {
    nav: {
      services: "Services",
      gallery: "Gallery",
      booking: "Book",
      contact: "Contact",
      callNow: "Call Now",
    },
    hero: {
      kicker: "Mobile Mechanic Service · Providence, RI",
      title1: "YOUR TRUSTED",
      title2: "MECHANIC",
      titleAccent: "ON WHEELS",
      subtitle:
        "We bring the shop to you. Fast, honest and professional service for your vehicle across Providence and surroundings.",
      ctaPrimary: "Book Service",
      ctaSecondary: "WhatsApp",
      stats: [
        { k: "5★", v: "Bilingual Service" },
        { k: "24/7", v: "Roadside Assistance" },
        { k: "100%", v: "Honest Work" },
      ],
    },
    ticker: [
      "Pro Diagnostics",
      "Mobile Service",
      "Bilingual Support",
      "Guaranteed Work",
      "Honest Pricing",
      "Fast Response",
    ],
    services: {
      kicker: "What we do",
      title: "MOBILE",
      titleAccent: "SERVICES",
      subtitle: "Real repairs, done where you are. No tow trucks, no long waits.",
      items: [
        {
          name: "Battery Change",
          desc: "Fast replacement and full electrical system load test.",
        },
        {
          name: "Brakes",
          desc: "Pads, rotors and complete brake system service.",
        },
        {
          name: "Tune-Ups",
          desc: "Spark plugs, filters and full maintenance for top performance.",
        },
        {
          name: "Diagnostic Scan",
          desc: "Professional OBD-II code reading right at your location.",
        },
        {
          name: "Oil Change",
          desc: "Premium oil and filter. Conventional, synthetic or blend.",
        },
        {
          name: "Alternators & Starters",
          desc: "Diagnostic and replacement for alternators, starters and batteries.",
        },
        {
          name: "Pre-Purchase Inspection",
          desc: "Full inspection before you buy your next used car.",
        },
        {
          name: "Roadside Assistance",
          desc: "Rescues, jump starts and emergency on-the-spot repairs.",
        },
      ],
    },
    gallery: {
      kicker: "Work in action",
      title: "IN THE",
      titleAccent: "GARAGE",
      subtitle: "Real results. Clean and professional work.",
    },
    booking: {
      kicker: "Request your appointment",
      title: "BOOK",
      titleAccent: "YOUR SERVICE",
      subtitle: "Tell us what your car needs and where you are. We'll confirm shortly.",
      trust: [
        { t: "Fast Response", d: "Same-day response across Providence and surroundings." },
        { t: "Honest Diagnostic", d: "We explain the real issue before charging you." },
        { t: "Bilingual Support", d: "We speak English and Spanish. No miscommunications." },
        { t: "Written Warranty", d: "We back every job we complete." },
      ],
      form: {
        name: "Full name",
        phone: "Phone",
        location: "Location / Address",
        vehicle: "Vehicle (Year / Make / Model)",
        serviceType: "Service type",
        description: "Describe the issue",
        submit: "Send Request",
        sending: "Sending...",
        success: "Request sent! We'll contact you very soon.",
        error: "Couldn't send your request. Try again or call (417) 514-0081.",
        selectService: "Select a service",
      },
    },
    contact: {
      kicker: "Just one call away",
      title: "CALL US",
      titleAccent: "NOW",
      phone: "Phone",
      whatsapp: "WhatsApp",
      area: "Service Area",
      areaValue: "Providence, RI & surroundings",
    },
    footer: {
      tagline: "Your trusted mechanic on wheels.",
      rights: "All rights reserved.",
    },
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState("es");

  const toggle = useCallback(() => {
    setLang((l) => (l === "es" ? "en" : "es"));
  }, []);

  const value = useMemo(
    () => ({ lang, setLang, toggle, t: translations[lang] }),
    [lang, toggle]
  );
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}
